import { useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { trackAlwaysOnDataLayer } from '../../../../util/tag-manager';
import { identifyCustomer } from '../../../../util/bloomreach';
import { useCustomer } from 'hooks/customer';
import { RehydrationWatcher } from 'components/_shared/widgets/rehydration';
import { HydrationStateEnum } from 'types/redux';
import { PageLayoutProps } from 'types/types';

/**
 * NOTE: Has to be done in the layout because we need access to the redux provider.
 */
const GTMAlwaysOnListener = ({
  gtmPageTitle,
}: {
  gtmPageTitle: PageLayoutProps['gtmPageTitle'];
}) => {
  const customer = useCustomer();
  const cartItems = useSelector((state: RootState) => state.cart.cart.items);
  const hasTrackedAlwaysOn = useRef(false);

  const track = useCallback(() => {
    if (hasTrackedAlwaysOn.current) return;
    if (customer) identifyCustomer(customer);
    trackAlwaysOnDataLayer({
      user: customer,
      pageTitle: gtmPageTitle,
      numberItemsInCart: cartItems.reduce(
        (acc, item) => acc + item.quantity,
        0
      ),
    });
    hasTrackedAlwaysOn.current = true;
  }, [cartItems, customer, gtmPageTitle]);

  return (
    <RehydrationWatcher
      onRehydrate={track}
      onTimeOut={track}
      watchedStates={[HydrationStateEnum.cart, HydrationStateEnum.customer]}
    />
  );
};

export default GTMAlwaysOnListener;
